import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ClientService } from "../../../../../../services/clientService";
import NotificationManager from "react-notifications/lib/NotificationManager";
import APP_ROUTES from "src/helper/app-routes";
import { useLocation } from "react-router";
import { renderErrors } from "src/helper/error-message-helper";
import ClientQuestionnaireService from "./functionToSaveQuestionnaireFromPortal";

const AdverseChildhood = ({
  list,
  questionId,
  response,
  isPrint,
  isFromCP,
  token,
  queId,
}) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const selectedClientId = useSelector((state) => state.selectedClientId);
  const [loading, setLoading] = useState(false);
  // State for storing list items and their respective dropdown values
  const [listItems, setListItems] = useState(list);
  useEffect(() => {
    calculateSum();
  }, [listItems]);

  useEffect(() => {
    setListItems(list);
  }, [list]);

  useEffect(() => {
    const updatedGAD = list.map((question) => {
      const matchingQuestion = response?.find(
        (item) => item.questionId === question.questionId
      );

      if (matchingQuestion) {
        if (question.type === "radio") {
          return {
            ...question,
            value: matchingQuestion.value,
          };
        } else if (question.type === "checkbox") {
          return {
            ...question,
            value:
            matchingQuestion.value === "true" ||
            matchingQuestion.value === "True" ||
            matchingQuestion.value === "1" ||
            matchingQuestion.value === 1
              ? 1
              : 0,          
          };
        } else {
          return {
            ...question,
            value: matchingQuestion.value === "true" ? 1 : 0,
          };
        }
      }
      return question;
    });
    setListItems(updatedGAD);
  }, [response]);

  // State for storing the total sum
  const [totalSum, setTotalSum] = useState(0);

  const handleCheckboxChange = (itemId) => {
    const updatedItems = listItems.map((item) => {
      if (item.id === itemId) {
        return { ...item, value: !item.value };
      }
      return item;
    });
    setListItems(updatedItems);
  };

  const handleRadioChange = (id, value) => {
    const updatedItems = listItems.map((item) => {
      if (item.id === id) {
        return { ...item, value: value };
      }
      return item;
    });
    setListItems(updatedItems);
  };

  const calculateSum = () => {
    const checkedItems = listItems.filter(
      (item) => item.value && item.type !== "radio"
    );
    const sum = checkedItems.reduce((acc, item) => acc + item.value, 0);
    setTotalSum(sum);
  };

  const handleSubmit = async () => {
    await ClientService.insertClientQuestionnaire(
      selectedClientId,
      totalSum,
      listItems,
      questionId,
      queId,
      token
    )
      .then((result) => {
        let questionList = result.resultData;
        navigate(APP_ROUTES.QUESTIONNAIRE);
        NotificationManager.success("Add successfully");
      })
      .catch((error) => {
        setLoading(false);
        renderErrors(error.message);
      });
  };

  const condition1 = 1;
  const condition2 = "true";
  const foundItem = listItems?.find(
    (item) => item.value === condition1 || item.value === condition2
  );
  const handleSaveFromPortal = async () => {
    ClientQuestionnaireService.updatequestionnaireFromPortal(selectedClientId, totalSum, listItems, queId, token)
  }

  const handleCompleteFromPortal = async () => {
    try {
      ClientQuestionnaireService.completeQuestionnaireFromPortal(false, queId, selectedClientId, totalSum, listItems,  {isCompleted: true, inProgress: false, sentToClientPortal: null}, token)
    } catch (error) {
      console.error('Error completing client questionnaire:', error);
      NotificationManager.error('Failed to complete client questionnaire');
    }
  };

  
  return (
    <div className="col-12">
      <div className="ACE_main_table mt-3">
        <div className="head-4">
          ACE - Adverse Childhood Experience Questionnaire for Adults
        </div>
        <label className="pb-3 mt-2 border-bottom">
          <b>Instructions: </b> Below is a list of 10 categories of Adverse
          Childhood Experiences (ACEs). From the list below, please place a
          checkmark next to each ACE category that you experienced prior to your
          18th birthday. Then, please add up the number of categories of ACEs
          you experienced and put the total number at the bottom.
        </label>
      </div>

      {isPrint ? (
        foundItem || listItems[listItems.length - 1].isSelected ? (
          <>
            {listItems.map((item) => (
              <div className="row mb-3 py-2 border-bottom">
                <div className="col-12">
                  <label key={item.id} className="list_unstyled-cus-table">
                    {item.id}. {item.name}
                  </label>
                </div>
                {item.type === "radio" ? (
                  item.buttons.map((btn) => (
                    <label key={btn.value} className="cats_label">
                      <input
                        type="radio"
                        name={`item${item.id}`}
                        value={btn.value}
                        disabled={
                          isFromCP ? false : response && response.length > 0
                        }
                        checked={item.value === btn.value}
                        onChange={() => handleRadioChange(item.id, btn.value)}
                        className="mr-2 mb-0 ml-3"
                      />
                      {btn.label}
                    </label>
                  ))
                ) : item.type === "checkbox" ? (
                  <div className="col-12  select_table_phq select-table-drops">
                    <input
                      type="checkbox"
                      checked={item.value}
                      disabled={
                        isFromCP ? false : response && response.length > 0
                      }
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ))}
          </>
        ) : null
      ) : (
        listItems.map((item) => (
          <div className="row mb-3 py-2 border-bottom">
            <div className="col-12">
              <label key={item.id} className="list_unstyled-cus-table">
                {item.id}. {item.name}
              </label>
            </div>
            {item.type === "radio" ? (
              item.buttons.map((btn) => (
                <label key={btn.value} className="cats_label">
                  <input
                    type="radio"
                    name={`item${item.id}`}
                    value={btn.value}
                    disabled={
                      isFromCP ? false : response && response.length > 0
                    }
                    checked={item.value === btn.value}
                    onChange={() => handleRadioChange(item.id, btn.value)}
                    className="mr-2 mb-0 ml-3"
                  />
                  {btn.label}
                </label>
              ))
            ) : item.type === "checkbox" ? (
              <div className="col-12  select_table_phq select-table-drops">
                <input
                  type="checkbox"
                  checked={item.value}
                  disabled={isFromCP ? false : response && response.length > 0}
                  onChange={() => handleCheckboxChange(item.id)}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        ))
      )}

      <div className="text-start justify-content-start total_phq col-12">
        <p>ACE Score: </p>
        <p className="submitButon mb-0">{totalSum}</p>
      </div>

      {/* {state == null &&  !isPrint? (
        <div className="text-start mt-3 col-12">
          <button onClick={handleSubmit} className="submitButon">
            Submit
          </button>
        </div>
      ) : (
        ""
      )} */}

      {isFromCP ? (
        <div className="text-start mt-3 col-12">
          <button onClick={handleCompleteFromPortal} className="submitButon">
            Save & Complete
          </button>
          <button onClick={handleSaveFromPortal} className="cancelBtn">
            Save progress
          </button>
        </div>
      ) : state == null && !isPrint ? (
        <div className="text-start mt-3 col-12">
          <button onClick={handleSubmit} className="submitButon">
            Submit
          </button>
        </div>
      ) : null}

      <p className="f-12 mt-3">
        Copyright © 1999 Pfizer Inc. All rights reserved. Reproduced with
        permission.
      </p>
    </div>
  );
};

export default AdverseChildhood;
